import { Component } from '@angular/core';
import { UIButtonsComponent } from '@features/dev/ui-components/buttons/ui-buttons.component';
import { SidebarThemeSwitchComponent } from '@core/components/sidebar/components/user-menu/theme/sidebar-theme-switch.component';
import { UITogglesComponent } from '@features/dev/ui-components/toggle/ui-toggles.component';
import { UIBadgesComponent } from '@features/dev/ui-components/badges/ui-badges.component';
import { UIPaginationComponent } from '@features/dev/ui-components/pagination/ui-pagination.component';
import { UIAlertsComponent } from '@features/dev/ui-components/alerts/ui-alerts.component';
import { DialogService } from '@group24ag/flowkit';
import { UIDialogsComponent } from '@features/dev/ui-components/dialog/ui-dialogs.component';
import { UIInputsComponent } from '@features/dev/ui-components/inputs/ui-inputs.component';
import { UISelectComponent } from '@features/dev/ui-components/select/ui-select.component';
import { UISearchSelectComponent } from '@features/dev/ui-components/search-select/ui-search-select.component';
import { UIMenuComponent } from '@features/dev/ui-components/menu/ui-menu.component';
import { UITextAreasComponent } from '@features/dev/ui-components/text-area/ui-text-areas.component';
import { UIMultiSelectComponent } from '@features/dev/ui-components/select/ui-multiselect.component';
import { UICheckboxesComponent } from './checkboxes/checkboxes.component';
import { UITablesComponent } from '@features/dev/ui-components/tables/ui-tables.component';
import { UITooltipsComponent } from '@features/dev/ui-components/tooltips/ui-tooltips.component';
import { UIExpandableComponent } from '@features/dev/ui-components/expandable/ui-expandable.component';
import { UIRatingComponent } from '@features/dev/ui-components/rating/ui-rating.component';
import { UIFileUploadComponent } from '@features/dev/ui-components/file-upload/ui-file-upload.component';
import { UIProgressComponent } from '@features/dev/ui-components/progress/ui-progress.component';
import { UIStatusIdentifiersComponent } from '@features/dev/ui-components/status-identifiers/ui-status-identifiers.component';
import { UIDropdownMenuComponent } from '@features/dev/ui-components/dropdown-menu/ui-dropdown-menu.component';
import { UISpinnerComponent } from '@features/dev/ui-components/spinner/ui-spinner.component';
import { UIStepperComponent } from '@features/dev/ui-components/stepper/ui-stepper.component';
import { UIDatePickerComponent } from '@features/dev/ui-components/date-picker/ui-date-picker.component';
import { UITabsButtonComponent } from '@features/dev/ui-components/tabs/ui-tabs-button.component';
import { UIAvatarComponent } from '@features/dev/ui-components/avatar/ui-avatar.component';
import { UIRadioButtonsComponent } from '@features/dev/ui-components/radio-buttons/ui-radio-buttons.component';
import { UIDateRangePickerComponent } from '@features/dev/ui-components/date-range-picker/ui-date-range-picker.component';
import { UICardComponent } from '@features/dev/ui-components/card/ui-card.component';

@Component({
  selector: 'app-ui-components',
  providers: [DialogService],
  imports: [
    SidebarThemeSwitchComponent,
    UIAlertsComponent,
    UIBadgesComponent,
    UIButtonsComponent,
    UICheckboxesComponent,
    UIDatePickerComponent,
    UIDialogsComponent,
    UIExpandableComponent,
    UIInputsComponent,
    UIMenuComponent,
    UIMultiSelectComponent,
    UIPaginationComponent,
    UIRatingComponent,
    UISearchSelectComponent,
    UISelectComponent,
    UITablesComponent,
    UITextAreasComponent,
    UITogglesComponent,
    UITooltipsComponent,
    UIFileUploadComponent,
    UIProgressComponent,
    UIStatusIdentifiersComponent,
    UIDropdownMenuComponent,
    UISpinnerComponent,
    UIStepperComponent,
    UITabsButtonComponent,
    UIAvatarComponent,
    UIRadioButtonsComponent,
    UIDateRangePickerComponent,
    UICardComponent,
  ],
  template: `
    <div class="base--bg h-full overflow-y-scroll p-5">
      <div class="flex w-full justify-end">
        <app-sidebar-theme-switch />
      </div>
      <div class="flex flex-col gap-20">
        <app-ui-buttons />
        <app-ui-badges />
        <app-ui-status-identifiers />
        <app-ui-toggles />
        <app-ui-pagination />
        <app-ui-alerts />
        <app-ui-dialogs />
        <app-ui-inputs />
        <app-ui-text-areas />
        <app-ui-search-select />
        <app-ui-select />
        <app-ui-multiselect />
        <app-ui-date-picker />
        <app-ui-date-range-picker />
        <app-ui-menu />
        <app-ui-dropdown-menu />
        <app-ui-checkboxes />
        <app-ui-radio-buttons />
        <app-ui-tables />
        <app-ui-tooltips />
        <app-ui-expandable />
        <app-ui-progress />
        <app-ui-rating />
        <app-ui-file-upload />
        <app-ui-spinner />
        <app-ui-stepper />
        <app-ui-tabs-button />
        <app-ui-avatar />
        <app-ui-card />
      </div>
    </div>
  `,
})
export class UIComponentsComponent {}
